export function isNullOrWhitespace<V = string> (value: V | null | undefined): boolean {
  return value === null || value === undefined || `${value}`.trim() === '';
}
